import { isBefore, isSameDay } from 'date-fns'

import type { HoldingDto, HoldingWeekDto } from '@hcr/api/consumer'
import { filter, flow, getPropertyValue, sort } from '@hcr/utils'

import { compareDates, toDestinationDate } from '../../../dates'

const isFutureOrCurrentWeek = (week: HoldingWeekDto): boolean => {
  const today = toDestinationDate(new Date())
  const weekStart = toDestinationDate(week.week_start)
  const weekEnd = toDestinationDate(week.week_end)

  return isSameDay(weekStart, today) || isBefore(today, weekStart) || isBefore(today, weekEnd)
}

export const selectNextHoldingWeeks: (holding: HoldingDto) => HoldingWeekDto[] = flow(
  getPropertyValue('weeks'),
  filter(isFutureOrCurrentWeek),
  sort({
    comparer: compareDates,
    asc: getPropertyValue('week_start'),
  })
)
